import React, { useMemo } from "react";
import { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import AsynchronousAutocomplete from "../Autocomplete/AsynchronousAutocomplete";
import { Checkbox, FormControlLabel } from "@mui/material";

function CategoryFilter(props) {
  const extraFilters = [];
  let numberPerPage = 30;
  let showOnlyProductsCheckbox = props.showOnlyProductsCheckbox ?? true;

  if (props.vestiging_id) {
    extraFilters.push(props.vestiging_id);
    numberPerPage = 1000;
  }
  if (props["vestiging.venue_id"]) {
    extraFilters.push(props["vestiging.venue_id"]);
  }
  if (props["menukaart.id"]?.has !== undefined) {
    extraFilters.push(props["menukaart.id"]);
  }

  const filterOnNull = props["menukaart.id"]?.has === false;

  if (showOnlyProductsCheckbox === false && filterOnNull) {
    props.setFilter("menukaart.id", null);
  }

  const value = useMemo(() => {
    const value =
      props["menukaart.id"]?.value != null && Array.isArray(props["menukaart.id"].value)
        ? props["menukaart.id"].value.map((o, index) => ({
            value: o,
            label: props["menukaart.id"].label[index],
            vestiging_id: props["menukaart.id"].vestiging_id[index],
          }))
        : [];
    return value ?? [];
  });

  return (
    <>
      <AsynchronousAutocomplete
        async={{
          url: `core/kaarten/search?fields=id,id as value,naam as label,vestiging_id,producten_count&sort_field=naam&sort_dir=asc`,
          searchField: "naam",
          perPage: numberPerPage,
          extraFilters: extraFilters,
        }}
        getOptionLabel={(row) => {
          if (row.producten_count != null) {
            return row.label + ` (${row.producten_count})`;
          } else {
            return row.label;
          }
        }}
        key={JSON.stringify(extraFilters)}
        multiple={true}
        onChange={(e, option) => {
          if (option && option.length > 0) {
            // console.log(option);
            props.setFilter("menukaart.id", {
              field: "menukaart.id",
              operator: "in",
              value: option.map((o) => o.value),
              label: option.map((o) => o.label),
              vestiging_id: option.map((o) => o.vestiging_id),
            });
          } else {
            props.setFilter("menukaart.id", null);
          }
        }}
        placeholder={getTranslation("Filter on Category")}
        title={
          filterOnNull
            ? getTranslation(
                "categories.filters.select.title_on_disabled",
                "Disable 'only show products without a group' to select a category"
              )
            : ""
        }
        value={value}
        // can't have both filters active at the same time, they're mutually exclusive.
        disabled={filterOnNull}
      />
      {showOnlyProductsCheckbox ? (
        <FormControlLabel
          control={
            <Checkbox
              checked={filterOnNull}
              color={"primary"}
              onChange={(e) => {
                if (e.target.checked) {
                  props.setFilter("menukaart.id", {
                    field: "menukaart.id",
                    has: false,
                    value: [],
                    label: getTranslation(
                      "categories.filters.selectone.disabled",
                      "Showing only products without a group"
                    ),
                    vestiging_id: props.vestiging_id?.value,
                  });
                } else {
                  props.setFilter("menukaart.id", null);
                }
              }}
            />
          }
          label={getTranslation(
            "categories.filters.checkbox.onlyShowProductsWithoutGroup",
            "Only show products without a group"
          )}
        />
      ) : null}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    ["vestiging.venue_id"]: state.filtersV2["vestiging.venue_id"],
    vestiging_id: state.filtersV2.vestiging_id,
    ["menukaart.id"]: state.filtersV2["menukaart.id"],
  };
};

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryFilter);
